export const deedStyles = {
  backgroundColor: '#fff',
  boxShadow: '0 1px 6px rgba(199, 205, 235, 0.4)',
  display: 'flex',
  marginBottom: 10,
};
